import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { StoreRouterConnectingModule } from '@ngrx/router-store';

import { environment } from '../../environments/environment';
import { reducers, metaReducers } from './index';

// Feature state modules
import { AuthStateModule } from './auth/auth-state.module';
import { UserStateModule } from './user/user-state.module';
import { LanguageStateModule } from './language/language-state.module';
import { UiStateModule } from './ui/ui-state.module';
import { CareStateModule } from './care/care-state.module';
import { SafetyAnalyticsStateModule } from './safety-analytics/safety-analytics-state.module';
import { RemindersAnalyticsStateModule } from './reminders-analytics/reminders-analytics-state.module';
import { CommunicationAnalyticsStateModule } from './communication-analytics/communication-analytics-state.module';
import { MatchingAnalyticsStateModule } from './matching-analytics/matching-analytics-state.module';

/**
 * Root State Module
 */
@NgModule({
  imports: [
    StoreModule.forRoot(reducers, {
      metaReducers,
      runtimeChecks: {
        strictStateImmutability: true,
        strictActionImmutability: true,
        strictStateSerializability: false,
        strictActionSerializability: false,
        strictActionWithinNgZone: false,
        strictActionTypeUniqueness: true,
      }
    }),
    EffectsModule.forRoot([]),
    StoreRouterConnectingModule.forRoot(),
    StoreDevtoolsModule.instrument({
      maxAge: 25,
      logOnly: environment.production,
      autoPause: true,
      trace: false,
      traceLimit: 75,
    }),

    // Feature state modules
    AuthStateModule,
    UserStateModule,
    LanguageStateModule,
    UiStateModule,
    CareStateModule,
    SafetyAnalyticsStateModule,
    RemindersAnalyticsStateModule,
    CommunicationAnalyticsStateModule,
    MatchingAnalyticsStateModule,
  ],
  exports: [
    StoreModule,
    EffectsModule,
    StoreDevtoolsModule,
    StoreRouterConnectingModule,
    AuthStateModule,
    UserStateModule,
    LanguageStateModule,
    UiStateModule,
    CareStateModule,
    SafetyAnalyticsStateModule,
    RemindersAnalyticsStateModule,
    CommunicationAnalyticsStateModule,
    MatchingAnalyticsStateModule,
  ]
})
export class StateModule {}
